import { render } from "./AppComments.vue?vue&type=template&id=5e738339&scoped=true"
import script from "./AppComments.vue?vue&type=script&lang=js"
export * from "./AppComments.vue?vue&type=script&lang=js"

import "./AppComments.vue?vue&type=style&index=0&id=5e738339&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e738339"]])

export default __exports__